/* global __PLATFORM__, __PLATFORM_NAMES__ */
///////////// ENVIRONMENT VARISABLES INITIALISATION //////////////
//TEST IF WEBPACK PASSED A GLOBAL VAR (work only in online : not for offline)
import { INIT_ENV_VARS } from "./mixins/UtilsEnvironment";
try {
  if (__PLATFORM__) {
    INIT_ENV_VARS(__PLATFORM__, __PLATFORM_NAMES__);
  }
} catch (e) {
  console.log("no global env vars, so app should have been set apart manually");
}

//GLOBAL IMPORT CSS for Activity here to not be imported be mobile app

//console.log(GET_PLATFORM(), GET_PLATFORM_NAMES(), ISPLATFORM_NAME("chrome50"));
//////////////////////////////////////////
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueMatomo from "vue-matomo"; // dual Vue2/Vue3 compatible internally (checks Vue.version)
import "./services/http-common";
import { server, MATOMO_ENABLED } from "./config/settings-network.mjs";
import "./styles/main.scss";

import store from "./store";
import Buefy from "buefy";
import { i18n } from "./i18n";
import CountryFlag from "./components/CountryFlag.vue"; // local replacement, vue-country-flag has no Vue3 version

///Styles et icons

import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

// PACK FAR (regular/outline) @fortawesome/free-regular-svg-icons
// Used for the empty-star state in the sequence results (SequenceView.vue /
// BilanSequenceModal.vue): fas gives the filled + half-filled stars, far gives
// the outline for stars not earned.
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(far);

//PACK FAB @fortawesome/free-brands-svg-icons
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fab);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const app = createApp(App);

app.use(router);
app.use(store);
app.use(i18n);

app.component("country-flag", CountryFlag);
app.component("vue-fontawesome", FontAwesomeIcon);

app.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
    fab: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
    far: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x",
      },
      iconPrefix: "",
    },
  },
});

////////////////////
//MOMENT SETTINGS
const moment = require("moment");
// CB to Tony : Force MOMENT A SE CHARGER EN FR, à changer pour que la langue corresponde à i18$
//require("moment/locale/fr");
require("moment/min/locales.min");
moment.locale(navigator.language.trim().split(/-|_/)[0]);
// Replaces the vue-moment filter (removed in Vue3, `{{ x | moment(...) }}` is no longer valid syntax).
// Only the two call shapes actually used in templates are covered: `.format(fmt)` and `.fromNow()`.
app.config.globalProperties.$formatMoment = (value, format) => {
  const d = moment(value);
  return d.isValid() ? d.format(format) : value;
};
app.config.globalProperties.$momentFromNow = (value) => {
  const d = moment(value);
  return d.isValid() ? d.fromNow() : value;
};

/////////////////////
//////ANALYTICS MATOMO for production server
if (MATOMO_ENABLED && server == "production") {
  app.use(VueMatomo, {
    host: "https://analytics.kdetude.eu",
    siteId: 2,
    trackerFileName: "matomo",
    router: router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    requireCookieConsent: false,
    enableHeartBeatTimer: false,
    heartBeatTimerInterval: 15,
    debug: false,
    userId: store.state.auth.user
      ? store.state.auth.user.username
      : "non authentifié",
    cookieDomain: undefined,
    domains: undefined,
    preInitActions: [],
    trackSiteSearch: true,
  });
}

// Wait for the router to resolve the initial route (including fetching its async component
// chunk, e.g. lazy-loaded SequenceView) before the first paint. Without this, on a cold load
// $route.meta.hideHeader is still undefined when App.vue first renders, so the header/footer
// flash visible before disappearing once the route (and its meta) actually resolves.
router.isReady().then(() => {
  app.mount("#app");
});
